import { render, staticRenderFns } from "./QPagination.vue?vue&type=template&id=495193d2"
import script from "./QPagination.vue?vue&type=script&lang=js"
export * from "./QPagination.vue?vue&type=script&lang=js"
import style0 from "./QPagination.vue?vue&type=style&index=0&id=495193d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports